import { View } from 'react-native'

import { styled } from '~/utils'

export const Root = styled(View, theme => {
  return {
    base: {
      paddingRight: theme.paddingInsetFourpulse,
      paddingLeft: theme.paddingInsetTwelvepulse,
      paddingBottom: theme.paddingInsetFourpulse,
      paddingTop: theme.spacingStackTwopulse,
      backgroundColor: 'transparent',
    },
    variants: {
      withIcon: {
        false: {
          paddingLeft: theme.paddingInsetFourpulse,
        },
      },
      isLink: {
        true: {
          paddingLeft: theme.paddingInsetEightpulse,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          withIcon: false,
          isLink: true,
        },
        css: {
          paddingLeft: theme.paddingInsetNone,
        },
      },
    ],
  }
})
